/* eslint-disable */
import React from 'react';

// @mui
import { Container } from '@mui/material';

// components
import Page from '../../components/Page';

import { AudioProvider } from '../../utils/eSteth/AudioState';
import HomePage from './HomePage';

// ----------------------------------------------------------------------

export default function ESteth() {
  return (
    <Page title="ESteth UI">
      <Container maxWidth="xl">
        <AudioProvider>
          <HomePage />
        </AudioProvider>
      </Container>
    </Page>
  );
}
